export default state => ({
  ...state,
  saveProductDesignAlert: true,
});
